// The chat's waiting flag (ReaderPage isFetchingResponse) has two writers: a
// reading turn (Get Reading, the Mystics tab's "Get a reading", Ask the cards)
// and the page's entry, which clears it when it is done. A turn sent from
// inside the entry (beginPendingAsk runs in start_session) was cleared by the
// entry's end while the server still held the grounding pause: no ring, no
// dots, an empty pane until the first question (Chris, 2026-10-31). The entry
// now clears it only when no turn is out.
export function fetchingGate(flag) {
  let out = 0
  return {
    async turn(send) {
      out += 1
      flag.value = true
      try {
        return await send()
      } finally {
        out -= 1
        if (!out) flag.value = false
      }
    },
    entryDone() {
      if (!out) flag.value = false
    },
    get busy() { return out > 0 },
  }
}
